import FinalFormField from 'common/components/final-form/FinalFormField';
import React from 'react';
import { Button, FormCheck, FormGroup, FormLabel } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import { IVacationRentalPresenter } from './VacationRentalPresenter';
import { VacationRentalRequest } from './VacationRentalRequest';

function VacationRentalForm(props: IVacationRentalPresenter) {
  return (
    <Form<VacationRentalRequest> onSubmit={props.onSubmit}>
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <FinalFormField
            label='License Type: *'
            name='licenseType'
            type='select'
            options={[
              { cd: '', descr: '--' },
              { cd: 'VACATION_RENTAL', descr: 'Vacation Rentals' },
              { cd: 'BED_BREAKFAST', descr: 'Bed & Breakfast' },
            ]}
          />
          <FinalFormField
            type='number'
            label='License Number: *'
            name='licenseNum'
          />
          <FormGroup>
            <FormLabel>Platform(s): *</FormLabel>
          </FormGroup>

          <Field name='intermediaries' type='checkbox' value='HOMEAWAY'>
            {({ input }) => (
              <FormGroup>
                <FormCheck
                  {...input}
                  id='HOMEAWAY'
                  label='Vrbo / HomeAway / Expedia'
                  type='checkbox'
                />
              </FormGroup>
            )}
          </Field>
          <Field name='intermediaries' type='checkbox' value='AIRBNB'>
            {({ input }) => (
              <FormGroup>
                <FormCheck
                  {...input}
                  id='AIRBNB'
                  label='AirBnB'
                  type='checkbox'
                />
              </FormGroup>
            )}
          </Field>
          <FinalFormField
            label='Name as listed on license: *'
            name='legalName'
          />

          <Button variant='primary' type='submit' disabled={props.saving}>
            Submit
          </Button>
        </form>
      )}
    </Form>
  );
}

export default VacationRentalForm;
